import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import TableActionButton from "../../../../@ui/TableActionButton";
import PublicTransportService from "../../../../services/PublicTransportService";
import { AlertType } from "../../../../types/AlertMessage";
import { SnapshotWindow } from "../../../../types/LayerAdmin/SnapshotWindow";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";
import { useAlertContext } from "../../../alert/AlertContext";
import SnapshotModal from "../../../modal/LayerAdmin/PublicTransport/SnapshotModal";
import SortableTable from "../../../Table/SortableTable";
import { TableAction } from "../../../Table/TableAction";

const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

interface SnapshotTableProps {
  publicTransportService: PublicTransportService;
}

const SnapshotTable = ({ publicTransportService }: SnapshotTableProps) => {
  const [snapshot, setSnapshot] = useState<SnapshotWindow[]>([]);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const { layerName } = useParams();
  const { showAlert } = useAlertContext();

  const handleSubmit = (windowStartDate: DateTime, windowEndDate: DateTime) => {
    publicTransportService
      .SetSnapshotWindow(windowStartDate, windowEndDate)
      .then((_) => {
        publicTransportService
          .GetSnapshotWindow()
          .then(setSnapshot)
          .catch(() => {});
        showAlert({
          message: "Snapshot set successfully. Downloads are starting. Check Downloads page for progress.",
          type: AlertType.Information,
          duration: 10000
        });
        setShow(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    publicTransportService
      .GetSnapshotWindow()
      .then(setSnapshot)
      .catch(() => {});
  }, [publicTransportService]);

  const viewFeeds = (snapshot: SnapshotWindow) => {
    navigate(`/admin/layers/${layerName!}/snapshots/${snapshot.quarter}`);
  };

  const viewPtImports = (snapshot: SnapshotWindow) => {
    navigate(`/admin/layers/${layerName!}/snapshots/${snapshot.quarter}/imports`);
  };

  const cols: TableColumn[] = [
    {
      displayName: "Quarter",
      field: "quarter",
      sortable: false,
    },
    {
      displayName: "Start Date",
      field: "windowStartDate",
      sortable: false,
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
    },
    {
      displayName: "End Date",
      field: "windowEndDate",
      sortable: false,
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy",
    },
  ];

  const actions = [
    { onClick: viewFeeds, show: true, content: "Feeds" },
    { onClick: viewPtImports, show: true, content: "Imports" },
  ] as TableAction[];

  return (
    <>
      <div className="mr-1 w-100 text-end mb-1">
        <TableActionButton onClick={() => setShow(true)}>
          {" "}
          <StyledIcon icon={faPlus} />
          Create Snapshot
        </TableActionButton>
      </div>
      <SortableTable actions={actions} columns={cols} data={snapshot} />
      <SnapshotModal
        show={show}
        onClose={() => setShow(false)}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default SnapshotTable;
